import { useEffect, useState } from 'react';

// 14 de noviembre de 2026 a las 13:30 (acceso) en Ciudad de México (UTC−6).
const eventDate = Date.UTC(2026, 10, 14, 19, 30, 0);

function getRemaining() {
  const seconds = Math.max(
    0,
    Math.floor((eventDate - Date.now()) / 1000)
  );

  return [
    Math.floor(seconds / 86400),
    Math.floor((seconds % 86400) / 3600),
    Math.floor((seconds % 3600) / 60),
    seconds % 60
  ];
}

export default function Countdown() {
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const timer = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="countdown-wrap">
      <span className="eyebrow countdown-heading">
        EL ENCUENTRO COMIENZA EN
      </span>
      <div
        className="countdown"
        aria-label={`Faltan ${remaining[0]} días, ${remaining[1]} horas, ${remaining[2]} minutos y ${remaining[3]} segundos`}
      >
        {remaining.map((value, index) => (
          <div className="count-unit" key={index}>
            <strong>{String(value).padStart(2, '0')}</strong>
            <span>{['DÍAS', 'HORAS', 'MIN', 'SEG'][index]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}